export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  thumbnail: string;
  author: string;
  publishDate: string;
  readTime: string;
  tags: string[];
  views: number;
}

export const articles: Article[] = [
  {
    id: 'a001',
    title: '2026年最值得期待的十大国产电影，每一部都让人热血沸腾',
    excerpt: '2026年中国电影市场持续升温，从科幻巨制到历史史诗，从动画精品到现实题材，一大批优秀作品即将与观众见面。茄子视频为您盘点年度必看国产电影。',
    content: `<p>2026年，中国电影市场迎来了空前的繁荣期。随着国产电影工业化水平的不断提升和创作生态的日益成熟，越来越多高品质、高口碑的作品走进观众的视野。今天，茄子视频为大家整理了2026年最值得期待的十大国产电影。</p>
<h3>1. 《流浪地球3：星辰大海》</h3>
<p>作为中国科幻电影的标杆，《流浪地球》系列第三部将继续由郭帆执导，吴京、刘德华等原班人马回归。故事讲述地球在星际漂流中遭遇全新危机的史诗故事，视觉效果全面升级，预计暑期档上映。</p>
<h3>2. 《长安十二时辰之天机变》</h3>
<p>改编自马伯庸同名小说的电影续作，延续电视剧版的高口碑，雷佳音再度出演张小敬一角。影片将呈现更加宏大和精致的大唐盛景。</p>
<h3>3. 《山海经之异兽觉醒》</h3>
<p>以中国上古奇书《山海经》为蓝本的奇幻冒险大片，讲述少年与上古异兽共同拯救世界的故事。影片投资超5亿，特效由国际顶尖团队打造。</p>
<h3>4. 《穿越火线之终极对决》</h3>
<p>林超贤执导的现代军事动作片，彭于晏、张涵予领衔主演。影片取景中东多地，实战感极强的战斗场面令人期待。</p>
<h3>5. 《深海危机》</h3>
<p>中国首部深海灾难片，讲述深海科考队遭遇未知生物袭击的惊悚故事。由《流浪地球》特效团队担纲制作，视觉效果值得期待。</p>
<p>这些作品涵盖了科幻、古装、动作、灾难等多种类型，充分展现了中国电影多元化发展的趋势。茄子视频将持续关注这些影片的最新动态，并在上映后第一时间为观众带来高清在线观看体验。</p>`,
    category: 'movies',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20movie%20industry%20article%20header%2C%20film%20reels%20and%20cinema%20lighting%2C%20modern%20cinematography%20aesthetic%2C%20warm%20dramatic%20tones%2C%20editorial%20photography%20style%2C%20clean%20minimal%20background&width=800&height=450&seq=qiezi-art-001&orientation=landscape',
    author: '茄子影视编辑部',
    publishDate: '2026-08-05',
    readTime: '8分钟',
    tags: ['电影', '国产电影', '票房', '影视资讯'],
    views: 125000,
  },
  {
    id: 'a002',
    title: '《三体》动画版第二季热播：国产科幻动画的里程碑之作',
    excerpt: '《三体之黑暗森林》上线首周播放量突破1亿，豆瓣评分9.6。这部改编自刘慈欣经典科幻小说的动画作品，正在重新定义国产动画的高度。',
    content: `<p>近日，《三体》动画版第二季《黑暗森林》正式上线茄子视频，首周播放量即突破1亿大关，豆瓣评分高达9.6分，成为2026年暑期档最受关注的动画作品。</p>
<h3>制作水准全面提升</h3>
<p>相比第一季，《黑暗森林》在制作水准上有了质的飞跃。画面精细度大幅提升，人物建模更加自然流畅，场景渲染达到了国际一流水准。尤其是「面壁计划」的视觉呈现，令人叹为观止。</p>
<h3>忠实还原原著精神</h3>
<p>本季动画在改编过程中非常注重对原著精神的把握。罗辑、章北海等角色的塑造深刻而立体，「黑暗森林法则」的阐述层次分明、引人深思。许多原著粉丝表示「这季动画完美呈现了想象中的三体世界」。</p>
<h3>中国动画工业化的里程碑</h3>
<p>《三体》动画系列的成功，标志着中国动画工业化达到了一个新的高度。从前期策划、中期制作到后期特效，全流程实现了标准化管理。制作团队超过800人，历时3年打造，总投资超过2亿元。</p>
<h3>海外影响力持续扩大</h3>
<p>值得一提的是，《黑暗森林》同步在多个海外平台上线，英文字幕版受到国际观众的高度评价。许多海外科幻迷表示「这是一部不输于任何好莱坞制作的科幻动画」。中国科幻正在以动画为载体，走向世界舞台。</p>
<p>茄子视频作为《三体》动画系列的独家网络播放平台，将持续为观众提供4K超高清观看体验。还没看的朋友，快来茄子视频一睹为快吧！</p>`,
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20animation%20three-body%20problem%20article%20header%2C%20cosmic%20space%20and%20technology%2C%20modern%20animation%20aesthetic%2C%20warm%20orange%20and%20dark%20contrast%2C%20editorial%20style%2C%20clean%20minimal%20background&width=800&height=450&seq=qiezi-art-002&orientation=landscape',
    author: '茄子动画观察',
    publishDate: '2026-08-03',
    readTime: '6分钟',
    tags: ['三体', '国产动画', '科幻', '刘慈欣'],
    views: 98000,
  },
  {
    id: 'a003',
    title: '暑期档综艺大战：谁将成为今夏综艺之王？',
    excerpt: '2026年暑期档综艺市场竞争激烈，《奔跑吧》第十季、《乘风破浪的姐姐》第五季、《吐槽大会》第八季等王牌节目悉数回归。茄子视频为您深度解析今夏综艺格局。',
    content: `<p>每年暑期档都是各大视频平台综艺节目的必争之地。2026年的暑期档更是精彩纷呈，多档王牌综艺节目同期回归，为观众带来了一场视听盛宴。</p>
<h3>《奔跑吧》第十季：经典IP的持续进化</h3>
<p>作为中国最长寿的户外竞技真人秀之一，《奔跑吧》迎来了第十个年头。本季节目在保持原有欢乐基调的基础上，增加了更多挑战性和深度内容，首播即创下收视新高。常驻嘉宾之间的化学反应愈发默契，飞行嘉宾的加盟也为节目注入了新鲜活力。</p>
<h3>《乘风破浪的姐姐》第五季：女性力量的绽放</h3>
<p>30位30+姐姐再度用实力证明「年龄只是数字」。本季节目邀请了来自演艺、音乐、体育等多个领域的优秀女性，她们在舞台上的精彩表现引发了广泛的社会讨论，成为今夏最具话题性的综艺节目之一。</p>
<h3>《吐槽大会》第八季：笑声中的社会观察</h3>
<p>吐槽大会以犀利的语言和巧妙的幽默，成为观众释放压力的最佳选择。新一季节目在保持「犀利吐槽」本色的同时，更加注重正向价值观的传递，实现了娱乐与思考的平衡。</p>
<h3>新综艺的崛起</h3>
<p>除了这些王牌节目，一些新形态综艺也在崛起。音乐旅行真人秀《声入人心之旅》、文化探访节目《非遗里的中国》等节目凭借独特的创意和精良的制作，收获了大量好评。</p>
<p>茄子视频汇聚了今夏最全的综艺节目库，无论你喜欢哪种类型的综艺，都能在这里找到属于你的欢乐时光。打开茄子视频，快乐即刻开始！</p>`,
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20summer%20article%20header%2C%20TV%20studio%20with%20colorful%20lights%20and%20stage%2C%20entertainment%20atmosphere%2C%20warm%20vibrant%20tones%2C%20editorial%20style%2C%20clean%20minimal%20background&width=800&height=450&seq=qiezi-art-003&orientation=landscape',
    author: '茄子综艺观察',
    publishDate: '2026-07-28',
    readTime: '7分钟',
    tags: ['综艺', '暑期档', '奔跑吧', '乘风破浪的姐姐'],
    views: 87000,
  },
  {
    id: 'a004',
    title: '国产纪录片为何越来越受欢迎？揭秘背后的创作密码',
    excerpt: '从《舌尖上的中国》到《地球脉动之亚洲秘境》，国产纪录片近年来频频出圈。茄子视频深度剖析国产纪录片崛起的三大原因。',
    content: `<p>曾几何时，纪录片被视为「小众」和「枯燥」的代名词。然而近年来，国产纪录片频频登上热搜、引发全民讨论，成为视频内容消费的重要品类。这一转变背后，折射出中国纪录片创作的深刻变革。</p>
<h3>一、叙事方式的革新</h3>
<p>传统的纪录片往往采用「播音腔」的旁白说教模式，而新一代国产纪录片在叙事上更加注重故事性和情感共鸣。《舌尖上的中国》用美食讲人情，《我在故宫修文物》以匠心传文化，《人生一串》用烟火气诉人间。这些作品打破了观众对纪录片的刻板印象。</p>
<h3>二、技术水平的飞跃</h3>
<p>随着拍摄设备和后期制作技术的升级，国产纪录片的视觉品质已经达到国际一流水准。4K超高清、航拍、微距摄影、水下摄影等技术的广泛应用，为观众带来前所未有的视觉震撼。《地球脉动之亚洲秘境》的摄影师团队在喜马拉雅山区驻扎三个月，只为捕捉一个完美的日出镜头。</p>
<h3>三、内容选题的多元化</h3>
<p>从自然地理到历史人文，从美食旅游到科技前沿，国产纪录片的选题范围越来越广。《敦煌：千年回响》讲述丝路文明的辉煌，《创新中国》记录科技工作者的奋斗，《人生第一次》聚焦普通人的生活瞬间。多元化的选题让不同口味的观众都能找到自己喜爱的内容。</p>
<h3>未来展望</h3>
<p>随着中国文化自信的提升和观众审美水平的提高，国产纪录片正在迎来黄金发展期。茄子视频将持续引进和制作高品质纪录片内容，为观众打开一扇了解世界的窗口。</p>`,
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20documentary%20film%20making%20article%20header%2C%20camera%20equipment%20and%20nature%20scenery%2C%20professional%20documentary%20production%2C%20warm%20natural%20lighting%2C%20editorial%20style%2C%20clean%20minimal%20background&width=800&height=450&seq=qiezi-art-004&orientation=landscape',
    author: '茄子文化频道',
    publishDate: '2026-07-20',
    readTime: '6分钟',
    tags: ['纪录片', '国产纪录片', '影视制作', '文化'],
    views: 65000,
  },
  {
    id: 'a005',
    title: '《大江大河之春雷》热播：改革开放题材为何总能打动人心？',
    excerpt: '电视剧《大江大河之春雷》自开播以来热度持续走高，豆瓣评分9.5。这部聚焦改革开放年代的电视剧，为何能持续引发观众共鸣？',
    content: `<p>《大江大河之春雷》自上线茄子视频以来，热度持续攀升，豆瓣评分稳定在9.5分，成为2026年口碑最好的电视剧之一。这部剧延续了《大江大河》系列的品质，以改革开放初期的中国为背景，讲述了几位年轻人在时代洪流中奋斗成长的故事。</p>
<h3>真实的时代质感</h3>
<p>《大江大河》系列最打动人心的地方，在于它对时代细节的精准还原。从服装道具到场景布置，从人物语言到社会氛围，每一个细节都充满了上世纪80年代的时代质感。这种真实感让经历过那个年代的观众倍感亲切，也让年轻一代观众对那个充满激情的年代产生了强烈的好奇与向往。</p>
<h3>奋斗精神的传承</h3>
<p>剧中主人公们面对困难不屈不挠的奋斗精神，在今天依然具有强烈的现实意义。无论是宋运辉的技术攻关，还是雷东宝的创业历程，都展现了中国人在改革开放大潮中勇于拼搏、敢于创新的精神品质。这种精神跨越时空，激励着每一代观众。</p>
<h3>精湛的演员表演</h3>
<p>王凯、杨烁、董子健三位主演的表演堪称教科书级别。他们不仅在外形上贴近角色，更在精神气质上与角色融为一体。每一个眼神、每一个动作都充满了角色的生命力，让人完全沉浸在故事之中。</p>
<h3>时代之问的当代回响</h3>
<p>《大江大河之春雷》虽然讲述的是过去的故事，但其中蕴含的关于理想与现实、个人与集体、传统与创新的思考，在今天的中国依然具有深刻的现实意义。这也是为什么这部剧能够跨越年龄层，引发广泛共鸣的核心原因。</p>
<p>茄子视频为您提供《大江大河之春雷》全42集高清在线观看，每晚8点更新两集，追剧不等待！</p>`,
    category: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20period%20series%20article%20header%2C%20vintage%20factory%20and%20reform%20era%20aesthetic%2C%20warm%20nostalgic%20tones%2C%20editorial%20style%2C%20clean%20minimal%20background&width=800&height=450&seq=qiezi-art-005&orientation=landscape',
    author: '茄子剧评',
    publishDate: '2026-07-15',
    readTime: '7分钟',
    tags: ['电视剧', '大江大河', '年代剧', '国产剧'],
    views: 112000,
  },
  {
    id: 'a006',
    title: '从观众到创作者：茄子视频如何赋能独立视频创作者',
    excerpt: '在内容创作民主化的时代，茄子视频通过「创作者扶持计划」为独立创作者提供技术、流量和变现支持，助力优质原创内容的生长。',
    content: `<p>在移动互联网时代，每个人都有机会成为内容创作者。茄子视频深知优质原创内容是平台的灵魂，因此推出了全方位的「创作者扶持计划」，为独立视频创作者提供从内容生产到商业变现的一站式解决方案。</p>
<h3>零门槛入驻，全方位支持</h3>
<p>茄子视频的创作者平台采用零门槛入驻政策，任何有创作热情的个人或团队都可以申请成为茄子视频创作者。审核通过后，创作者即可享受平台提供的多项支持服务，包括视频上传、内容管理、数据分析等基础功能。</p>
<h3>智能分发，精准触达</h3>
<p>茄子视频自研的AI推荐算法会根据内容质量和用户偏好，将创作者的视频精准推送给最可能感兴趣的目标观众。这不仅提高了内容的曝光效率，也帮助创作者快速积累粉丝。</p>
<h3>多元化变现，让创作有价值</h3>
<p>茄子视频为创作者提供多元化的变现渠道，包括广告分成、用户打赏、付费内容、品牌合作等。优质创作者还可以参与平台的「星火计划」，获得额外的流量扶持和创作基金。</p>
<h3>创作者成功案例</h3>
<p>自创作者扶持计划推出以来，已有超过5000名创作者从中受益。美食创作者「厨房里的老王」从零起步，一年内积累了超过50万粉丝；旅行博主「行走的相机」通过茄子视频实现了全职创作的自由生活。</p>
<p>如果你也怀揣创作梦想，欢迎加入茄子视频创作者大家庭。在这里，每一个好的创意都值得被看见！</p>`,
    category: 'platform',
    thumbnail: 'https://readdy.ai/api/search-image?query=Video%20creator%20content%20creation%20workspace%20article%20header%2C%20modern%20studio%20with%20equipment%2C%20creative%20atmosphere%2C%20warm%20lighting%2C%20editorial%20style%2C%20clean%20minimal%20background&width=800&height=450&seq=qiezi-art-006&orientation=landscape',
    author: '茄子创作者中心',
    publishDate: '2026-07-08',
    readTime: '6分钟',
    tags: ['创作者', '原创内容', '视频创作', '平台资讯'],
    views: 45000,
  },
];

export function getArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getRelatedArticles(currentId: string, category: string, limit: number = 3): Article[] {
  return articles
    .filter((a) => a.id !== currentId && a.category === category)
    .slice(0, limit);
}

export function getPopularArticles(limit: number = 5): Article[] {
  return [...articles].sort((a, b) => b.views - a.views).slice(0, limit);
}